"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recipePreviewFragment = exports.AllRecipeLinkFragment = exports.AllIngredientHeaderFragment = exports.AllRegularIngredientFragment = void 0;
const client_1 = require("@apollo/client");
exports.AllRegularIngredientFragment = client_1.gql `
  fragment AllRegularIngredients on RegularIngredient {
    __typename
    sid
    editedByUser
    name
    unit
    amount
    keyword
  }
`;
exports.AllIngredientHeaderFragment = client_1.gql `
  fragment AllIngredientHeader on IngredientHeader {
    __typename
    text
  }
`;
exports.AllRecipeLinkFragment = client_1.gql `
  fragment AllRecipeLink on RecipeLink {
    __typename
    recipeId
    amount
    unit
    name
  }
`;
exports.recipePreviewFragment = client_1.gql `
  fragment RecipePreview on Recipe {
    __typename
    name
    pictureUrl
    smallPictureUrl
    description
    id
    notes
    ingredients {
      ... on RegularIngredient {
        ...AllRegularIngredients
      }
      ... on IngredientHeader {
        ...AllIngredientHeader
      }
      ... on RecipeLink {
        ...AllRecipeLink
      }
    }
    instructions
    times {
      __typename
      type
      value
    }
    youtubeVideoId
    source
    sourceUrl
    servings
    privacy
    shareId
    owner
    createdAt
    rating
  }

  ${exports.AllRegularIngredientFragment}
  ${exports.AllIngredientHeaderFragment}
  ${exports.AllRecipeLinkFragment}
`;
//# sourceMappingURL=recipePreviewFragment.js.map